export const BrandConfig = {
    productNameOnTwoLines: ['CHANE'],
    notUnderlined: ['CHANE'],
};
